class ProductsScroller extends HTMLElement {
    constructor() {
        super();

        this.scroller = document.querySelector('#Scroller');
        this.items = document.querySelectorAll('.product-item');
        this.windowHeight = this.items[0].offsetHeight;

        this.touchStartY = 0;
        this.touchEndY = 0;
        this.lastScrollTop = this.scroller.scrollTop;

        this.lastClientY = 0;
        this.lastClientX = 0;

        this.arrowTips = this.querySelectorAll('.arrow-tip');
        this.tipTimeout = null;

        this.applyClasses(Math.round(this.scroller.scrollTop / this.windowHeight));
        this.applyTipClasses(Math.round(this.scroller.scrollTop / this.windowHeight));
        this.initEvents();
    }

    applyClasses(currentIndex) {
        for (let i = 0; i < this.items.length; ++i) {
            const item = this.items[i];
            item.classList.remove('--selected');
            if (i === currentIndex) item.classList.add('--selected');
        }
    }

    applyTipClasses(currentIndex) {
        if (this.items.length <= 1) {
            this.arrowTips[0].classList.remove('--show');
            this.arrowTips[1].classList.remove('--show');
            return;
        }

        if (currentIndex == 0) {
            this.arrowTips[0].classList.remove('--show');
        } else {
            this.arrowTips[0].classList.add('--show');
        }

        if (currentIndex == this.items.length - 1) {
            this.arrowTips[1].classList.remove('--show');
        } else {
            this.arrowTips[1].classList.add('--show');
        }
    }

    updateCurrentProduct() {
        const scrollPosition = this.scroller.scrollTop;
        const currentIndex = Math.round(scrollPosition / this.windowHeight);

        if (currentIndex <= -1) {
            return;
        }

        this.lastScrollTop = scrollPosition;
        this.arrowTips[0].classList.remove('--show');
        this.arrowTips[1].classList.remove('--show');
        this.applyClasses(currentIndex);
        this.shiftImages();

        if (this.tipTimeout) clearTimeout(this.tipTimeout);
        this.tipTimeout = setTimeout(() => {
            this.tipTimeout = null;
            this.applyTipClasses(currentIndex);
        }, 200);
    }

    selectFace(e) {
        const button = e.target;
        const face = button.dataset.face;
        const otherFace = face === 'a' ? 'b' : 'a';
        const otherButton = this.querySelector(`button[data-face="${otherFace}"]`);

        button.classList.remove('xtext-text-40');
        button.classList.add('xtext-text-90');

        otherButton.classList.add('xtext-text-40');
        otherButton.classList.remove('xtext-text-90');

        for (const image of this.querySelectorAll('img[data-face]')) {
            const imageFace = image.dataset.face;
            if (imageFace === face) {
                image.classList.remove('xhidden');
            } else {
                image.classList.add('xhidden');
            }
        }
    }

    shiftImages(e) {
        const image = this.querySelector('.product-item.--selected a');
        if (!image) return;
        const container = image.parentElement;

        const rect = container.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        const deltaX = (centerX - (e ? e.clientX : this.lastClientX)) / 80;
        const deltaY = (centerY - (e ? e.clientY : this.lastClientY)) / 80;

        if (e) {
            this.lastClientX = e.clientX;
            this.lastClientY = e.clientY;
        }

        image.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    }

    initEvents() {
        document.addEventListener('keydown', (e) => {
            const currentScroll = this.scroller.scrollTop;
            const itemHeight = this.windowHeight;

            if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                this.scroller.scrollTo({
                    top: Math.ceil(currentScroll / itemHeight) * itemHeight,
                    behavior: 'smooth',
                });
            } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                this.scroller.scrollTo({
                    top: Math.floor(currentScroll / itemHeight - 1) * itemHeight,
                    behavior: 'smooth',
                });
            }
        });

        this.scroller.addEventListener('touchstart', (e) => {
            this.touchStartY = e.touches[0].clientY;
        });

        this.scroller.addEventListener('touchend', (e) => {
            this.touchEndY = e.changedTouches[0].clientY;
            const diff = this.touchStartY - this.touchEndY;
            const itemHeight = this.windowHeight;
            const windowWidth = window.innerWidth;
            const currentScroll = this.scroller.scrollTop;

            if (Math.abs(diff) > 50) {
                // Seuil minimum pour déclencher le défilement
                if (diff > 0) {
                    // Swipe vers le haut

                    if (Math.ceil(currentScroll / itemHeight) >= this.items.length) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }

                    if (windowWidth > 750) {
                        this.scroller.scrollTo({
                            top: Math.ceil(currentScroll / itemHeight) * itemHeight,
                            behavior: 'smooth',
                        });
                    }
                } else {
                    if (Math.floor(currentScroll / itemHeight) < 0) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                    }
                    // Swipe vers le bas

                    if (windowWidth > 750) {
                        this.scroller.scrollTo({
                            top: Math.floor(currentScroll / itemHeight - 1) * itemHeight,
                            behavior: 'smooth',
                        });
                    }
                }
            }
        });

        // Mettre à jour l'indicateur pendant le défilement
        this.scroller.addEventListener('scroll', this.updateCurrentProduct.bind(this));

        const recommendedProductsDrawer = document.querySelectorAll('.product-recommended-drawer[data-product-id]');
        const productsInScroller = [];
        for (const item of this.items) {
            if (item.dataset.productId) productsInScroller.push(item.dataset.productId);
        }

        recommendedProductsDrawer.forEach((product) => {
            const itemIndex = productsInScroller.indexOf(product.dataset.productId);
            if (itemIndex > -1) {
                product.addEventListener('click', (event) => {
                    event.preventDefault();
                    window.callbackAction = () => {
                        setTimeout(() => {
                            const itemHeight = this.windowHeight;
                            this.scroller.scrollTo({
                                top: Math.floor(itemHeight * itemIndex),
                                behavior: 'smooth',
                            });
                        }, 200);
                    };
                });
            } else {
                product.removeAttribute('data-product-id');
            }
        });

        this.addEventListener('mousemove', this.shiftImages.bind(this));

        for (const button of this.querySelectorAll('button[data-face]')) {
            button.addEventListener('click', this.selectFace.bind(this));
        }

        this.arrowTips.forEach((elm) =>
            elm.addEventListener('click', (e) => {
                const actualScroll = this.scroller.scrollTop;
                const itemHeight = this.windowHeight;
                const direction = e.currentTarget.classList.contains('arrow-tip__prev') ? 'prev' : 'next';

                let top = actualScroll / itemHeight;
                if (direction === 'prev') {
                    top = Math.max(0, top - 1);
                } else {
                    top = Math.min(this.items.length - 1, top + 1);
                }
                this.scroller.scrollTo({
                    top: Math.floor(itemHeight * top),
                    behavior: 'smooth',
                });
            })
        );
    }
}

customElements.define('products-scroller', ProductsScroller);
